<template>
  <v-card class="size-chart-component pa-3" outlined>
    <v-row no-gutters>
      <v-col cols="12" class="mb-3">
        <div class="d-flex justify-space-between align-center">
          <div>
            <label> Size chart </label>
            <div class="helper-text">
              Add an image URL or upload an image for the product size chart.
            </div>
          </div>
          <div class="d-flex align-center">
            <!-- <a class="link-add mr-3" @click="showModelAddImage = true" style="cursor:pointer;">Add image from URL</a> -->
            <div v-if="preview">
              <v-btn small text color="error" @click="clear">
                <v-icon left>mdi-trash-can-outline</v-icon>
                Remove
              </v-btn>
            </div>
          </div>
        </div>
      </v-col>

      <v-col style="position: relative;" cols="12" md="12" class="pr-3">
        <div class="preview-box elevation-1" style="position:relative;">
          <template v-if="preview">
            <v-img :src="imageHelpers.url(preview, { width: 500, height: 500 })" contain class="rounded-preview" />
          </template>
          <template v-else>
            <div class="text-center text--secondary no-preview" style="cursor: pointer;">
              <v-icon size="56">mdi-upload</v-icon>
              <div class="mt-2">Upload Image</div>
              <div
                style="position: absolute; inset: 0; top: 0; left: 0; z-index: 99; display: flex; align-items: center; justify-content: center;"
              >
                <v-file-input
                  accept="image/*"
                  label="Upload image"
                  dense
                  prepend-icon="mdi-upload"
                  @change="onFileChange"
                  :counter="false"
                  style="width: 100%; opacity: 0; cursor: pointer;"
                  :loading="loading"
                />
              </div>
            </div>
          </template>
          <div v-if="loading" class="loading-overlay">
            <v-progress-circular indeterminate color="primary" size="48" />
          </div>
        </div>
        <!-- Dialog nhập link ảnh -->
        <v-dialog persistent v-model="showModelAddImage" width="500">
          <v-card class="pa-4">
            <div class="d-flex align-center justify-space-between mb-4">
              <h2 class="mb-0">Add link image</h2>
              <v-btn icon @click="showModelAddImage = false"><v-icon>mdi-close</v-icon></v-btn>
            </div>
            <v-text-field
              type="url"
              :error-messages="messageCheckImage"
              v-model="linkImage"
              placeholder="https://"
              hide-details=""
            ></v-text-field>
            <div class="d-flex justify-end mt-4">
              <v-btn color="primary" depressed @click="submitImageUrl">Save</v-btn>
            </div>
          </v-card>
        </v-dialog>
      </v-col>

      <v-col cols="12" md="12">
        <v-row>
          <v-col cols="12">
            <v-text-field
              v-model="link"
              placeholder="https://example.com/size-chart.jpg"
              dense
              hide-details
              clearable
              @input="onLinkInput"
            />
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import { uploadService } from '@/apis/upload.s';
import axios from 'axios';
import imageHelpers from '@/helpers/image';

export default {
  name: 'SizeChart',
  props: {
    value: {
      type: String,
      default: '',
    },
  },
  data() {
    // Ưu tiên lấy giá trị khởi tạo từ $parent.attributes.sizeChart nếu có
    let initial = '';
    if (this.$parent && this.$parent.attributes && this.$parent.attributes.sizeChart) {
      initial = this.$parent.attributes.sizeChart;
    } else if (this.value) {
      initial = this.value;
    }
    return {
      link: initial || '',
      preview: initial || null,
      messageCheckImage: '',
      linkImage: '',
      showModelAddImage: false,
      loading: false,
      imageHelpers,
    };
  },
  watch: {
    value(v) {
      this.link = v || '';
      this.preview = v || null;
    },
  },
  methods: {
    onLinkInput() {
      const v = this.link && this.link.trim() !== '' ? this.link.trim() : '';
      this.preview = v || null;
      this.$emit('input', v);
    },
    async onFileChange(file) {
      if (!file) return;
      let f = file;
      if (Array.isArray(file)) f = file[0];
      if (!f) return;
      this.loading = true;
      try {
        let type = f.name.split('.').pop();
        let id = this.objectId();
        let urlData = await uploadService.get({ filename: `image-${id}.${type}` });
        if (urlData && urlData.data && urlData.data.presignedUrl) {
          await axios.put(urlData.data.presignedUrl, f, {
            headers: {
              'Content-Type': `${f.type}`,
            },
          });
          const imageUrl = urlData.data.imagePath;
          this.preview = imageUrl;
          this.link = imageUrl;
          this.$emit('input', imageUrl);
        }
      } catch (error) {
        this.$store &&
          this.$store.commit &&
          this.$store.commit('setMessages', {
            messages: 'Error image upload',
            type: 'error',
          });
      }
      this.loading = false;
    },
    async checkImage(url) {
      var pattern = new RegExp(/^https?:\/\/.*\/.*\.(png|gif|webp|jpeg|jpg|webp)\??.*$/gim);
      return !!pattern.test(url);
    },
    async submitImageUrl() {
      this.messageCheckImage = '';
      let check = await this.checkImage(this.linkImage);
      if (check) {
        this.preview = this.linkImage;
        this.link = this.linkImage;
        this.$emit('input', this.linkImage);
        this.linkImage = '';
        this.showModelAddImage = false;
      } else {
        this.messageCheckImage = 'Url Error';
      }
    },
    objectId() {
      return this.hex(Date.now() / 1000) + ' '.repeat(16).replace(/./g, () => this.hex(Math.random() * 16));
    },
    hex(value) {
      return Math.floor(value).toString(16);
    },
    clear() {
      this.preview = null;
      this.link = '';
      this.$emit('input', '');
    },
  },
};
</script>

<style scoped>
.size-chart-component {
  width: 100%;
}
.helper-text {
  color: rgba(0, 0, 0, 0.6);
  font-size: 13px;
}
.preview-box {
  width: 100%;
  height: 180px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fafafa;
  border-radius: 8px;
}
.rounded-preview {
  max-width: 100%;
  max-height: 100%;
  border-radius: 6px;
}
.no-preview {
  padding: 12px;
}
.formats {
  color: rgba(0, 0, 0, 0.6);
  font-size: 12px;
}
</style>

<style scoped>
.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 100;
}
</style>
